export default "__VITE_ASSET__CBg5rjkb__"